import {useEffect, useState, useCallback} from 'react';
import {useAppDispatch} from '../../../store/hooks';
import {setTitle} from '../../../store/header/header.slice';
import OperatoriesElement from './OperatoriesElement';
import Container from '../../common/layout/Container';
import Error from '../../common/Error';
import Spinner from '../../common/Spinner';
import {RunningProcess} from '../../../constants/types';
import {AlertSettingsResponseProps} from '../../settings/alert_alarm/types';
import {getAllAlertSettings} from '../../../api/settings/alert_alarm';
import {getOperatoriesOverviewList} from '../../../api/operatories';
import {DEFAULT_ERROR} from '../../../api/constants';
import {processAlertType} from '../../settings/alert_alarm/constants';

export type OperatoryOverviewListResponseProps = {
  id: number,
  number : number,
  currentlyInUse: boolean,
  desc : string,
  process: RunningProcess
}

const OperatoriesOverview = () => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [operatoriesOverviewList, setOperatoriesOverviewList] =
  useState<Nullable<OperatoryOverviewListResponseProps[]>>(null);
  const [processesAlertData, setProcessesAlertData] =
  useState<Nullable<AlertSettingsResponseProps>>(null);

  const getData = useCallback(async () => {
    setIsLoading(true);

    try {
      const [
        operatoriesOverviewListResponse,
        processesAlertResponse
      ] = await Promise.all([
        getOperatoriesOverviewList(),
        getAllAlertSettings(processAlertType)
      ]);
      setOperatoriesOverviewList(operatoriesOverviewListResponse);
      setProcessesAlertData(processesAlertResponse);
    } catch (e) {
      setError(e?.message || DEFAULT_ERROR);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    dispatch(setTitle('Operatory Overview'));
    getData();
  }, []);

  return (
    <Container>
      <>
        {isLoading ? (
          <Spinner loadingText="Getting operatories overview list" />
        ) : (
          <div className="operatories-wrapper">
            {operatoriesOverviewList?.length &&
            operatoriesOverviewList.map((elemData) => (
              <OperatoriesElement
                data={elemData}
                key={elemData.id}
                processesAlertData={processesAlertData}/>
            ))}
          </div>
        )}
      </>
      {error && <Error message={error} />}
    </Container>
  );
};

export default OperatoriesOverview;
